import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { UserService } from '@inera/common';
import { filter, Subject, takeUntil } from 'rxjs';
import { DefaultRouteGuard } from 'src/app/security/default-route-guard.service';
import { IDMobileMenuModule } from '@inera/ids-angular/components/mobile/menu';
import {
  IDHeaderIneraAdminComponent,
  IDHeaderIneraAdminItemComponent,
  IDHeaderIneraAdminNavComponent,
  IDHeaderIneraAdminNavItemComponent,
} from '@inera/ids-angular/components/header-inera-admin';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    IDHeaderIneraAdminComponent,
    IDHeaderIneraAdminNavComponent,
    IDHeaderIneraAdminNavItemComponent,
    IDHeaderIneraAdminItemComponent,
    RouterModule,
    CommonModule,
    IDMobileMenuModule,
  ],
  templateUrl: './app-header.component.html',
  styleUrl: './app-header.component.scss',
})
export class AppHeaderComponent implements OnInit {
  private userService = inject(UserService);
  private router = inject(Router);
  private routeGuard = inject(DefaultRouteGuard);

  private destroy$ = new Subject<boolean>();

  public loggedIn = false;
  public isMobileMenuOpen = false;

  private currentPath: string = '';
  public navItems: NavItem[] = [];

  ngOnInit(): void {
    this.userService.connect().subscribe(user => {
      if (user) {
        this.loggedIn = true;
      } else {
        this.loggedIn = false;
      }
      this.updateNavItems();
    });
    this.router.events
      .pipe(
        takeUntil(this.destroy$),
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe(e => {
        this.currentPath = (e as NavigationEnd).url;
        this.updateNavItems();
      });
  }

  updateNavItems(): void {
    this.navItems = [
      {
        link: {
          label: 'Validering',
          route: 'validator/employeeplus',
        },
        active: this.currentPath.toLowerCase().includes('validator'),
      },
    ];

    if (this.loggedIn) {
      if (this.routeGuard.checkIfAuthorizedWithRoles(['ADMIN', 'CUSTOMER'])) {
        this.navItems.push(
          {
            link: {
              label: 'Tema',
              route: 'theme',
            },
            active: this.currentPath.toLowerCase().includes('theme'),
          },
          {
            link: {
              label: 'Klientregistrering',
              route: 'client-register',
            },
            active: this.currentPath.toLowerCase().includes('client-register'),
          },
          {
            link: {
              label: 'SSO-grupper',
              route: 'sso-groups',
            },
            active: this.currentPath.toLowerCase().includes('sso-groups'),
          },
          {
            link: {
              label: 'Statistik',
              route: 'statistics/overview',
            },
            active: this.currentPath.toLowerCase().includes('statistics'),
          }
        );
      }

      if (this.routeGuard.checkIfAuthorizedWithRoles(['ADMIN'])) {
        this.navItems.push({
          link: {
            label: 'Behörigheter',
            route: 'privilege',
          },
          active: this.currentPath.toLowerCase().includes('privilege'),
        });
      }

      if (this.routeGuard.checkIfAuthorizedWithRoles(['ADMIN'])) {
        this.navItems.push({
          link: {
            label: 'Fakturahantering',
            route: 'invoice-menu',
          },
          active: this.currentPath.toLowerCase().includes('invoice-menu'),
        });
      }
    }
  }
}

interface NavItem {
  link: {
    label: string;
    route: string;
  };
  active: boolean;
}
